import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { usePopupPopper, Popper } from '@workday/canvas-kit-react/popup';
import { useMenuModel } from './useMenuModel';
export const useMenuPopper = usePopupPopper;
export const MenuPopper = createSubcomponent('div')({
    displayName: 'Menu.Popper',
    modelHook: useMenuModel,
    elemPropsHook: useMenuPopper,
})(({ children, ...elemProps }) => {
    return (React.createElement(Popper, Object.assign({ placement: "bottom-start" }, elemProps), children));
});
